module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M6.8 19L20 5.7 18.4 4 6.8 15.7l-5.2-5.3L0 12.1z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/hook.svg
// module id = 59
// module chunks = 0